<template>
    <div class="side-bar">
        <a-menu mode="inline" :openKeys="openKeys" @openChange="onOpenChange" :inlineCollapsed="false"  :selectedKeys="selectedKeys" style="width: 180px;">
            <a-sub-menu :key="o.id" @titleClick="titleClick" v-for=" o in menuList" > 
                <span slot="title"><span>{{o.title}}</span></span>
                <a-menu-item :key="e.id" v-for="e in o.children" @click="clickItem(e)" style="padding:0;">{{e.title}}</a-menu-item>          
            </a-sub-menu>
        </a-menu>
    </div>
</template>
<script>
import {Menu} from 'ant-design-vue'
import { mapState,mapActions } from 'vuex'
import Bus from '@utils/bus'
import {http} from '@utils'
// import getAllRuleCategories from '@shared/data/getAllRuleCategories.json';

  export default {
    components:{'a-menu':Menu,'a-sub-menu':Menu.SubMenu,'a-menu-item':Menu.Item},
    data() {
      return {
        rootSubmenuKeys: [],
        openKeys: [],
        menuList:[],
        selectedKeys: [], // 当前选中的菜单项 key 数组
        isfirst: true
      };
    },
    computed:mapState([
      'csid',
    ]),
    watch: {
      '$store.state.csid': function(to, from) {
        const _selectedKeys = [this.getRootId(to)] 
        this.onOpenChange(_selectedKeys)
      },
    },
    async created(){
      Bus.$on('initSideBar', () => {  
            this.openKeys = []
        });
      await this.getMenus()
      const _sidercodeid = parseInt(this.$route.query.sidercode)
      if (_sidercodeid) {
        const _selectedKeys = [this.getRootId(_sidercodeid)] 
        this.onOpenChange(_selectedKeys)
      } 
    },
    computed: {
        sidercode: {
            get() {
                return this.$store.state.sidercode
            },
            set(v) {
                this.$store.commit('setSidercode',v)
            }
        }
    },
    methods: {
      ...mapActions(['toSearchByQuery']),
      async getMenus(){
        //const response = await http.get('@shared/data/getAllRuleCategories.json');
        this.menuList = await this.$store.dispatch('getMenus')
        this.rootSubmenuKeys = this.menuList.map((item) =>{
          return item.id
        })
      },
      // 根据子id反查父id
      getRootId(id) {
        var _id 
        this.selectedKeys = [id]
        this.menuList.forEach((items, indexs, arrays) => {
          if(1*id === items.id) {
            _id = items.id 
          } else {
            items.children.forEach((item,index, array) => {
              if(1*id === item.id) {
                _id = arrays[indexs].id
              }
            })
          }
        })
        return _id
      },
      onOpenChange(openKeys) {
        if(this.$route.sidercode == openKeys[0]) {
          return
        }
        const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
        // if (!this.$route.query.id) {
        //   if(this.isfirst) {
        //     this.isfirst = false
        //   } else {
        //     this.selectedKeys = []
        //   }
        // }

        if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
          this.openKeys = openKeys;
        } else {
          this.openKeys = [latestOpenKey] 
        }

      },
      clickItem(e){
        // console.log(e)
        this.selectedKeys = [e.id]
        this.toSearch(e.id)
        this.$store.dispatch('getId',e.id);

      },
      titleClick({ key, domEvent }){
        // console.log(domEvent)

        this.toSearch(key)
        this.$store.dispatch('getId',key);
      },
      toSearch(sidercode){
        const routeObj = { name: 'search', query: { sidercode }};
        // if(this.$route.query.sidercode == sidercode){return false}
        if(this.$route.name == 'search') {
          this.$router.replace(routeObj).catch(err => {err})
        } else {
          this.$router.push(routeObj).catch(err => {err})
        }
        const param = {
          sidercode:sidercode,
          current: 1,
          pagesize:10,
        }
        Bus.$emit('initSearchParams');
        this.toSearchByQuery(param);
      }
    },
  };
</script>
<style lang="scss">
 .side-bar {
  .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
    width: 10px;
    height: 10px;
    right: 20px;
    background: url('~@assets/images/down_arr.png') no-repeat;
    background-size: 100% auto;
    background-position: center center;
    transform: translateY(-50%);
    &:before,&:after {
      width: 0; 
    }
  }
  .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow  {
    background-image: url('~@assets/images/up_arr.png');
  }
  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    text-align: left;
    padding-left: 20px;
    margin: 0;
  }
  .ant-menu-inline .ant-menu-submenu.ant-menu-submenu-open {
    color: #333;
    
    >.ant-menu-submenu-title {
      font-weight: bold;
      color: #1C7AE5;
    }
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: #DFF1FF;
    font-size: 14px;
    color: #116CD0;
  }
  .ant-menu-sub.ant-menu-inline > .ant-menu-item {
    text-align: center;
    margin: 0;
    &:after {
      border:0;
    }
  }
 }
</style>

<style lang="scss" scoped>
 .side-bar {
   background-color: #fff;
   flex: 1 1 auto;
   .ant-menu {
     border:0;
   }
 }
</style>

